module.exports = __webpack_public_path__ + "static/media/stethoscope-pending-register.5e4694f0.svg";